import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export const CorrectionsFormLayout = () => {
  return (
    <FDStack spacing={1} wrap>
      <MetaControlField attr="account" flex={1} />
      <MetaControlField attr="correctedType" flex={1} />
    </FDStack>
  );
};
